import { AuthService } from './../../auth/auth.service';
import { catchError, flatMap, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { ProgressBarService } from '../components/header/progress-bar/progress-bar.service';
import { SnackComponent } from '../components/snack/snack.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  eTagRoutes: string[];

  /** Maps URL patterns to localStorage keys for offline fallback */
  private readonly offlineCacheMap: { pattern: RegExp; key: string; transform?: (data: any) => any }[] = [
    { pattern: /branch-items\/pos\//, key: 'PosItems', transform: d => ({ success: true, data: d }) },
    { pattern: /category\/findByBranch/, key: 'PosCategories', transform: d => ({ success: true, data: d }) },
    { pattern: /customer-branch\/delivery-methods\//, key: 'PosDeliveryMethods', transform: d => ({ success: true, data: d }) },
    { pattern: /issuing-type\/page/, key: 'PosInvoiceTypes', transform: d => ({ success: true, data: { content: d } }) },
    { pattern: /walking-consumer\/nameAndPhone/, key: 'PosOfflineCustomers', transform: d => ({ success: true, data: d }) },
    { pattern: /order-status\/findByStatusType/, key: 'PosOrderStatusType', transform: d => ({ success: true, data: { content: d } }) },
    { pattern: /\/api\/v1\/unit$/, key: 'PosUnit', transform: d => ({ success: true, data: d }) },
    { pattern: /pos-session\/last-session-user/, key: 'SessionData', transform: d => ({ success: true, data: d }) },
    { pattern: /portal-config\/get-config/, key: 'CONFIG', transform: d => ({ success: true, data: d }) },
    { pattern: /payment-card-type/, key: 'PaymentCardTypes', transform: d => ({ success: true, data: d }) },
  ];

  constructor(private _auth: AuthService, public _dialog: MatDialog, private _progressBarService: ProgressBarService,
    private snackBar: MatSnackBar,
  ) {
    this.eTagRoutes = ['api/v1/portal-config/get-config'];
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // 1) Bypass local asset/certificate requests (do not prepend apiUrl, do not add auth)
    const isLocalAsset = (
      request.url.startsWith('assets/') ||
      request.url.includes('/assets/') ||
      request.url.includes('./assets') ||
      request.url.startsWith('certificates/') ||
      request.url.includes('/certificates') ||
      request.url.includes('./certificates')
    );
    if (isLocalAsset) {
      request = request.clone({ url: `${request.url}` });
    }
    else if (request.url.includes('http://localhost:8282') || request.url.includes('http://localhost:8383')) {
      request = request.clone({
        headers: request.headers
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json, text/plain')
          .set('Access-Control-Allow-Origin', request.url.includes('http://localhost:8383') ? 'http://localhost:8383' : 'http://localhost:8282'),
        url: `${request.url}`,
      });
    }
    else if (request.url.includes('translation.googleapis.com')) {
      request = request.clone({
        url: `${request.url}`,
      });
    } else if (request.url.includes('bedrock/ask')) {
      // Exception for bedrock API - don't prepend environment.apiUrl
      const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
      request = request.clone({
        headers: request.headers
          .set('Content-Type', 'application/json;charset=UTF-8')
          .set('Authorization', `Bearer ${accessToken}`)
          .set('accept-language', localStorage.getItem('LANG'))
          .set('APP_TOKEN_HEADER', environment.appToken),
        url: `${request.url}`, // Keep original URL
      });
    } else if (request.url.includes('/upload/cloud/file')) {
      request = request.clone({
        headers: this.addHeadersForUpload(),
        url: `${environment.apiUrl}${request.url}`,
      });
    } else {
      // 2) API requests: prepend apiUrl and attach headers; skip Authorization if token is absent
      const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
      let headers = request.headers
        .set('Content-Type', 'application/json;charset=UTF-8')
        .set('accept-language', localStorage.getItem('LANG'))
        .set('APP_TOKEN_HEADER', environment.appToken);

      if (accessToken) {
        headers = headers.set('Authorization', `Bearer ${accessToken}`);
      }

      request = request.clone({
        headers,
        url: `${environment.apiUrl}${request.url}`,
      });
    }

    return next.handle(request).pipe(
      retry(0),
      // catchError((error: HttpErrorResponse) => {
      //   if (error.error?.status == 'Unauthorized') {
      //     // && error.error?.message.includes('JWT expired')
      //     return this._auth.refreshToken().pipe(
      //       flatMap((res) => {
      //         console.log(res)
      //         const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
      //         const req = request.clone({
      //           headers: request.headers //this.addHeaders(request.url),
      //             .set('Content-Type', 'application/json;charset=UTF-8')
      //             .set('Authorization', `Bearer ${accessToken}`)
      //             .set('accept-language', localStorage.getItem('LANG'))
      //             .set('APP_TOKEN_HEADER', environment.appToken),
      //           // .set('DEVICE_ID' ,this._auth.deviceId),
      //           url: `${request.url}`
      //         });
      //         return next.handle(req).pipe(
      //           catchError((error: HttpErrorResponse) => {
      //             console.log(error)
      //             //logout
      //             this._auth.logout();
      //             return throwError(new Error('error'));
      //           })
      //         );
      //       }));
      //   }
      //   // start print error message
      //   let errorMessage = '';
      //   if (error.error instanceof ErrorEvent) {
      //     // client-side error
      //     errorMessage = `Error: ${error.error.message}`;
      //   } else {
      //     // server-side error
      //     errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
      //     console.log(errorMessage);
      //   }
      //   this._progressBarService.hide();
      //   const printerCheckHealthError = 'http://localhost:8282/printer/health-check';
      //   const printerCheckHealthErrorIndex = error?.error?.message.indexOf(printerCheckHealthError);
      //   console.log(printerCheckHealthErrorIndex)
      //   // Check for specific error messages and statuses
      //   // Show motion dialog only for login endpoint with DisabledException (pending activation)
      //   const isLoginEndpoint = request.url.includes('/api/v1/auth/portal/login');
      //   const isDisabledException = error.error?.exception?.includes('DisabledException');
      //   if (error.status === 403 && isLoginEndpoint && isDisabledException) {
      //     this._auth.checkAccountValidity(error);
      //   } else if (this.shouldSkipErrorNotification(error)) {
      //     // Skip showing snack for specific error messages that we handle elsewhere
      //     console.log('Error notification skipped for custom handling:', error?.error?.message);
      //   } else if (request.url.includes('/public/')) {
      //     // Public routes: avoid snack disruption (like JWT empty) on non-critical calls
      //     console.warn('Public route error suppressed:', error?.error?.message || errorMessage);
      //   } else {
      //     this.showSnack(error?.error?.message, 'error');
      //   }

      //   return throwError(new Error(error?.error?.message || errorMessage));
      // })
      catchError((error: HttpErrorResponse) => {
        this._progressBarService.hide();

        // Attempt offline fallback for network errors (status 0 or no connection)
        if (!navigator.onLine || error.status === 0 || error.status === 504) {
          const fallback = this.getOfflineFallback(request.url);
          if (fallback) {
            return fallback;
          }
        }

        //  1. Handle Unauthorized
        if (error.status === 401) {
          // Check if account was deactivated (force logout with reason)
          const isAccountDeactivated = error.error?.code === 'ACCOUNT_DEACTIVATED';
          const isAccountSuspended = error.error?.code === 'ACCOUNT_SUSPENDED';
          if (isAccountDeactivated || isAccountSuspended) {
            this._auth.forceLogoutWithReason(error.error?.message || '', error.error?.code);
            return throwError(() => error);
          }

          return this._auth.refreshToken().pipe(
            flatMap(() => {
              const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
              const req = request.clone({
                headers: request.headers
                  .set('Content-Type', 'application/json;charset=UTF-8')
                  .set('Authorization', `Bearer ${accessToken}`)
                  .set('accept-language', localStorage.getItem('LANG'))
                  .set('APP_TOKEN_HEADER', environment.appToken),
                url: `${request.url}`
              });

              return next.handle(req).pipe(
                catchError((err: HttpErrorResponse) => {
                  this._auth.logout();
                  return throwError(() => err);
                })
              );
            })
          );
        }

        //   Special cases first (IMPORTANT)
        const isLoginEndpoint = request.url.includes('/api/v1/auth/portal/login');
        const isDeactivatedException = error.error?.code === 'ACCOUNT_DEACTIVATED';
        const isDisabledException = error.error?.exception?.includes('DisabledException');

        if (error.status === 403 && isLoginEndpoint && (isDeactivatedException || isDisabledException)) {
          this._auth.checkAccountValidity(error);
          return throwError(() => error);
        }

        // ✅ 3. Decide if we should show error
        const shouldSkip =
          this.shouldSkipErrorNotification(error) ||
          request.url.includes('/public/') ||
          request.url.includes('/report/pdf') ||
          request.url.includes('/report/excel');

        // ✅ 4. Show error ONLY if allowed
        if (!shouldSkip) {
          if (error.error instanceof Blob) {
            error.error.text().then(text => {
              try {
                const parsed = JSON.parse(text);
                if (parsed?.message) {
                  this.showSnack(parsed.message, 'error');
                }
              } catch (e) {
                console.error('Blob parse error:', e);
              }
            });
          } else if (error?.error?.message) {
            this.showSnack(error.error.message, 'error');
          }
        }

        // ✅ 5. Return error (safe)
        return throwError(() => error);
      })
    );
  }

  addHeader(endPoint): HttpHeaders {
    // const currentUser = JSON.parse(window.localStorage.getItem('CURRENT_USER'));
    const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
    const HEADERS = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      ...(accessToken && { Authorization: `Bearer ${accessToken}`, }),
      'accept-language': localStorage.getItem('LANG'),
      'APP_TOKEN_HEADER': environment.appToken,
    });
    if (this.eTagRoutes.includes(endPoint)) {
      HEADERS['If-None-Match'] = this.getMatchTag(endPoint) || null;
    }
    return HEADERS;
  }

  addHeadersForUpload(): HttpHeaders {
    // const currentUser = JSON.parse(window.localStorage.getItem('CURRENT_USER'));
    const accessToken = JSON.parse(localStorage.getItem('ACCESS_TOKEN'));
    const HEADERS = new HttpHeaders({
      ...(accessToken && {
        Authorization: `Bearer ${accessToken}`,
      }),
      'accept-language': localStorage.getItem('LANG'),
      'APP_TOKEN_HEADER': environment.appToken,
    });
    return HEADERS;
  }

  getMatchTag(endPoint) {
    let tag: string = null;
    const TAGS: any = JSON.parse(localStorage.getItem('TAGS')) || [];

    if (TAGS?.length > 0) {
      TAGS.forEach((TAG) => {
        if (TAG.endPoint === endPoint) {
          tag = TAG.eTag;
        }
      });
    }
    return tag;
  }

  /**
   * Determines if an error notification should be skipped based on the error message
   * @param error The HTTP error response
   * @returns true if the error notification should be skipped
   */
  shouldSkipErrorNotification(error: HttpErrorResponse): boolean {
    // Skip showing error notifications for these specific errors
    const skippedErrorMessages = [
      'Cannot invoke "com.service.hr.dto.BranchEmployeeCardDto.getId()" because "branchEmployeeCardDto" is null'
    ];

    // Check if the error message is in our list of skipped errors
    return skippedErrorMessages.some(message =>
      error?.error?.message?.includes(message)
    );
  }

  showSnack(message = 'erorr', type): void {
    const options: any = {};
    if (type === 'success') {
      options.icon = 'check_circle';
      options.icon_color = '#00C853';
    } else if (type === 'error') {
      options.icon = 'cancel';
      options.icon_color = '#BF360C';
    } else if (type === 'info') {
      options.icon = 'info';
      options.icon_color = '#2196F3';
    }
    this.snackBar.openFromComponent(SnackComponent, {
      data: {
        message,
        icon: options.icon,
        icon_color: options.icon_color,
        action_icon: 'close',
      },
      verticalPosition: 'bottom',
      horizontalPosition: 'left',
      duration: 30000,
    });
  }

  /**
   * Attempts to serve a response from localStorage when the app is offline.
   * Returns null if no cached data is available for the given URL.
   */
  private getOfflineFallback(url: string): Observable<HttpEvent<any>> | null {
    if (navigator.onLine) return null;

    for (const entry of this.offlineCacheMap) {
      if (entry.pattern.test(url)) {
        const raw = localStorage.getItem(entry.key);
        if (raw) {
          try {
            const data = JSON.parse(raw);
            const body = entry.transform ? entry.transform(data) : { success: true, data };
            console.log(`📴 Serving offline cached data for: ${entry.key}`);
            return of(new HttpResponse({ status: 200, body }));
          } catch (e) {
            console.warn(`Failed to parse offline cache for ${entry.key}`, e);
          }
        }
      }
    }
    return null;
  }
}
